import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

interface IncludeNamePillProps {
  name: string;
  on: boolean;
  onToggle: () => void;
  testId?: string;
}

/**
 * "With <child>" pill. Sits ABOVE the idea cards (Kai, 2026-08-30): the cards
 * star the child only while it is on, so the decision comes before the ideas.
 */
export default function IncludeNamePill({ name, on, onToggle, testId = 'include-name-toggle' }: IncludeNamePillProps) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={on}
      data-testid={testId}
      className={`flex items-center gap-1 min-h-10 px-3 py-2 rounded-full text-sm transition-colors ${
        on ? 'bg-primary text-white shadow-sm' : 'bg-stone-100 text-stone-600 hover:bg-stone-200'
      }`}
    >
      {on && <Check className="w-3.5 h-3.5" />}
      {t('create.includeName', { name })}
    </button>
  );
}
